
import { RutaLocal } from '../componentes/funcionesEspeciales'
import Logo from '../media/img/logo_principal.png'
function Historia() {

    return (<>
        <div className='container py-3' style={{ textAlign: "justify" }}>
            <h2>
                INFORMACIÓN SOBRE HISTORIA O INICIOS DE LA EMPRESA
            </h2>
            <br />
            <h5>
                Breve Historia
            </h5>
            <p>
                El Galpón - Pollos y parrillas, nace en el año 2007, en un pequeño local ubicado en el centro histórico de Arequipa, debido a la gran acogida hoy en día la empresa posee tres locales y es reconocido como un lugar bonito y tranquilo en dónde se puede disfrutar de un buen pollo a la brasa.
            </p>
            <h5>
                Misión
            </h5>
            <p>Expandir “El Galpón” a mediano plazo a todo el mercado arequipeño destacando dentro del rubro de las pollerías por el buen trato que ofrecemos a nuestros comensales; a largo plazo queremos llegar al mercado Limeño.</p>
            <h5>
                Visión
            </h5>
            <p>
                Ofrecer a nuestros consumidores comida de calidad preparados con insumos frescos, poniéndole un especial empeño a la buena atención al cliente, ofreciendo un cálido ambiente familiar.
            </p>
            <h5>
                NUESTROS VALORES
            </h5>
            <br />
            <p><b>Calidad</b></p>
            <p>Somos persistentes en mantenernos en pie frente a los obstáculos que puedan presentarse, siempre estamos aptos para cambiar de plan y buscar nuevas vías de solución. Nos preocupamos que nuestros insumos sean frescos, es por eso que verificamos que nuestros proveedores cumplan con las licencias de sanidad para ofrecer un producto y servicio de calidad.</p>
            <p><b>Persistencia</b></p>
            <p>Somos persistentes en mantenernos en pie frente a los obstáculos que puedan presentarse, siempre estamos aptos para cambiar de plan y buscar nuevas vías de solución.</p>
            <p><b>Motivación</b></p>
            <p>La motivación en nuestro equipo de trabajo es fundamental para ofrecer un buen servicio al cliente, por eso, es importante mantener la motivación entre nuestros colaboradores.</p>
            <p><b>Cortesía</b></p>
            <p>Ser cortés, es uno de los valores más importantes de nuestra organización, por eso, en el Galpón mantenemos un ambiente de cortesía y amabilidad con todos los que conforman el Galpón.</p>

        </div >
    </>)
}
export default Historia;